
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.445 2.578h-1.289v.645a1.936 1.936 0 01-1.933 1.933H7.777a1.936 1.936 0 01-1.933-1.933v-.645h-1.29a1.936 1.936 0 00-1.933 1.934V19.98c0 1.067.867 2.02 1.934 2.02h12.89c1.067 0 1.934-.953 1.934-2.02V4.512a1.936 1.936 0 00-1.934-1.934zM10.167 16.57l-2.579 2.578a.642.642 0 01-.91 0l-1.29-1.289a.644.644 0 11.911-.911l.834.833 2.122-2.122a.644.644 0 11.912.911zm0-4.512l-2.579 2.578a.642.642 0 01-.91 0l-1.29-1.289a.644.644 0 11.911-.911l.834.833 2.122-2.122a.644.644 0 11.912.911zm0-4.511l-2.579 2.578a.642.642 0 01-.91 0l-1.29-1.29a.644.644 0 11.911-.91l.834.833 2.122-2.123a.644.644 0 11.912.912zm5.99 10.5h-3.868a.644.644 0 110-1.288h3.867a.644.644 0 110 1.289zm0-4.51h-3.868a.644.644 0 110-1.29h3.867a.644.644 0 110 1.29zm0-4.513h-3.868a.644.644 0 110-1.289h3.867a.644.644 0 110 1.29z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.578 1.29h-1.21l-.152-.43A1.293 1.293 0 0011 0c-.545 0-1.034.346-1.216.86l-.152.43h-1.21c-.712 0-1.29.576-1.29 1.288v.645c0 .356.29.644.645.644h6.446a.645.645 0 00.644-.644v-.645c0-.712-.577-1.289-1.289-1.289z","fill":"#fff"}})])
          )
        }
      }
    